import { styled } from "styled-components";

export const StyledDashboardMessagesMainContent = styled.article`
  display: flex;
  width: 100%;
  gap: 16px;
  height: calc(100vh - 56px);
  align-items: flex-start;
  align-content: space-between;
  justify-content: space-between;
  gap: 0;
`;
